import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[comPopupHost]',
})
export class ComPopupHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
